import { getOrganizationEndpoint } from '../../api/platform-client.js';
export const buildStreamingRequest = async (state) => ({
    accessToken: state.configuration.accessToken,
    organizationId: state.configuration.organizationId,
    url: getOrganizationEndpoint(state.configuration.organizationId, state.configuration.environment),
    streamId: state.search.extendedResults?.generativeQuestionAnsweringId,
});
